import {
    renderDateCellFactory,
    renderDefaultTextCell,
} from "app/pages/sales-intelligence/common-components/table-cells";
import { NO_DATA_HYPHEN } from "app/pages/sales-intelligence/constants/common";
import type { BaseCrmRecordData } from "app/pages/sales-intelligence/domain/crm-integration/types/records";
import { CrmRecordCell } from "app/pages/sales-intelligence/modules/crm-integration/components/cells/CrmRecordCell";
import { COMMA_MMM_D_YYYY } from "app/services/date-time/formats";

export const renderCrmDateCell = (value: string) =>
    value === null || value === "" ? renderDefaultTextCell(NO_DATA_HYPHEN) : renderDateCellFactory(COMMA_MMM_D_YYYY)(value);

export const renderCrmRecordCell = (value: BaseCrmRecordData) => <CrmRecordCell value={value} />;

